import { 
    Box,
    Button,
    Switch,
    FormControl,
    FormLabel,
    Input,
    Text,
    VStack,
    Divider,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { updateMap } from "../../features/creator/creatorSlice";
import MapBackgroundSelector from "../../pages/page_elements/MapBackgroundSelector";
import { useEffect, useState } from "react";

export default function CreatorMapProperties({ map }) {

    const dispatch = useDispatch();

    const [selectedBackground, setSelectedBackground] = useState(map.background);
    const [enableWatermark, setEnableWatermark] = useState(map.watermark);
    const [mapName, setMapName] = useState(map.name);

    const handleSave = () => {
        dispatch(updateMap({
            mapId: map._id,
            enableWatermark: enableWatermark,
            background: selectedBackground,
            name: mapName,
        })).then(() => {
            window.location.reload();
        });
    };

    return (
        <Box p={4} borderWidth="1px" borderRadius="lg" overflow="hidden" bg="white" boxShadow="md" maxWidth="md" margin="auto" my={6}>
            <VStack spacing={6} align="stretch">

                <Box>
                    <FormControl display="flex" alignItems="center">
                        <FormLabel htmlFor="enable-watermark" mb="0">
                            Enable Watermark
                        </FormLabel>
                        <Switch 
                            id="enable-watermark" 
                            isChecked={enableWatermark}
                            onChange={(e) => setEnableWatermark(e.target.checked)}
                        />
                    </FormControl>
                </Box>

                <Divider />

                <Box>
                    <Text mb={2}>Background:</Text>
                    <MapBackgroundSelector
                        permitCustomMapBackground={true}
                        selectedBackground={selectedBackground}
                        setSelectedBackground={setSelectedBackground}
                    />
                </Box>

                <Box>
                    <Text>Name: </Text>
                    <Input 
                        placeholder={mapName}
                        onChange={(e) => setMapName(e.target.value)}
                    />
                </Box>

                <Button colorScheme="blue" onClick={handleSave}>
                    Save & refresh
                </Button>

            </VStack>
        </Box>
    )
}
